var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"clickable",on:{"click":function($event){return _vm.buttonClicked()}}},[(_vm.completed)?_c('img',{attrs:{"alt":"completed","src":require("../../../../../assets/images/completed.svg")}}):_c('img',{attrs:{"alt":"incomplete","src":require("../../../../../assets/images/incomplete.svg")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ef0d9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/client/items/mark-as-completed.vue
// module id = null
// module chunks = 